import { useCallback } from 'react';

import type { GlossaryKey } from '@izimi/components';
import { NabanGlossaryModal as BaseNabanGlossaryModal, useTracking } from '@izimi/components';
import { TrackingEventAction, TrackingEventCategory } from '@izimi/modules';

export const NabanGlossaryModal = () => {
  const { trackEvent } = useTracking();

  const onModalOpened = useCallback(
    ({ name }: { name: GlossaryKey }) => {
      trackEvent({
        category: TrackingEventCategory.General,
        action: TrackingEventAction.GlossaryModalOpened,
        name,
      });
    },
    [trackEvent],
  );

  return <BaseNabanGlossaryModal onModalOpened={onModalOpened} />;
};
